export const parseDate = dateStr => {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return isNaN(dateStr.getTime()) ? null : dateStr;
  let s = String(dateStr).trim();
  if (!s || s === 'null' || s === 'undefined' || s.startsWith('0001') || s.startsWith('1900')) return null;
  let d = new Date(s);
  if (isNaN(d.getTime())) {
    d = new Date(s.replace(' ', 'T'));
  }
  if (isNaN(d.getTime()) || d.getFullYear() <= 1970) return null;
  return d;
};

export const formatDate = dateStr => {
  const d = parseDate(dateStr);
  if (!d) return '-';
  return d.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatDateTime = dateStr => {
  const d = parseDate(dateStr);
  if (!d) return '-';
  return d.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const SUPPORT_LEVEL_OPTIONS = [
  { value: 1, label: 'Nivel 1 - Básico' },
  { value: 2, label: 'Nivel 2 - Avanzado' },
  { value: 3, label: 'Nivel 3 - Ingeniería' },
  { value: 4, label: 'Nivel 4 - Externo' }
];

export const formatDurationMinutes = mins => {
  if (mins === null || mins === undefined || isNaN(mins)) return null;
  const m = Number(mins);
  if (m < 1) return '< 1 min';
  if (m < 60) return `${m} min`;
  const hours = Math.floor(m / 60);
  const remMins = m % 60;
  if (hours < 24) {
    return remMins > 0 ? `${hours}h ${remMins}m` : `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  return remHours > 0 ? `${days}d ${remHours}h` : `${days}d`;
};

export const formatWaitingTimeFromDate = dateStr => {
  const d = parseDate(dateStr);
  if (!d) return null;
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 0) return '< 1 min';
  const diffMins = Math.floor(diffMs / 60000);
  return formatDurationMinutes(diffMins);
};
